import { render, staticRenderFns } from "./SignaturePerson.vue?vue&type=template&id=60c10ed6&"
import script from "./SignaturePerson.vue?vue&type=script&lang=js&"
export * from "./SignaturePerson.vue?vue&type=script&lang=js&"
import style0 from "./SignaturePerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c10ed6')) {
      api.createRecord('60c10ed6', component.options)
    } else {
      api.reload('60c10ed6', component.options)
    }
    module.hot.accept("./SignaturePerson.vue?vue&type=template&id=60c10ed6&", function () {
      api.rerender('60c10ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/SignaturePerson.vue"
export default component.exports